import * as React from 'react';
import { TPAComponentProps } from '../../types';
import { LegacyCardRatioOptions as OverlappingCardRatioOptions } from '../LegacyCard';

export { OverlappingCardRatioOptions };

export interface OverlappingCardProps extends TPAComponentProps {
  media?: React.ReactNode;
  info?: React.ReactNode;
  ratio?: OverlappingCardRatioOptions;
  flippedRatio?: boolean;
  invertInfoPosition?: boolean;
}
